import { prop } from "ramda";
import { createSelector } from "reselect";
import { STATE_IDENTIFIER } from "./constants";

const {
  REQUESTS_HISTORY_FETCH_LIMIT,
  RETRYABLE_REQUEST_TYPES,
  SMS_ENABLED,
  SMS_MOBILE_NUMBER_EDITABLE_BY_USER,
  MODIFY_PROFILE_CA_OTP_ENABLED,
  MODIFY_PROFILE_SEC_QUESTIONS_ENABLED,
  MODIFY_PROFILE_UIGP_OTP_ENABLED,
  DELEGATE_CONSULTANT_ENABLED,
} = STATE_IDENTIFIER;

const globalState = (state: any) => state.globalState;

export const selectReqHistoryCsvLimit: any = createSelector(
  globalState,
  prop(REQUESTS_HISTORY_FETCH_LIMIT)
);

export const selectRetryableReqTypes: any = createSelector(
  globalState,
  prop(RETRYABLE_REQUEST_TYPES)
);

export const selectSmsEnabled: any = createSelector(
  globalState,
  prop(SMS_ENABLED)
);

export const selectMobileNumberEditable: any = createSelector(
  globalState,
  prop(SMS_MOBILE_NUMBER_EDITABLE_BY_USER)
);

export const selectEditMobileCaOtpEnabled: any = createSelector(
  globalState,
  prop(MODIFY_PROFILE_CA_OTP_ENABLED)
);

export const selectEditMobileSecQuestEnabled: any = createSelector(
  globalState,
  prop(MODIFY_PROFILE_SEC_QUESTIONS_ENABLED)
);

export const selectEditMobileUigpOtpEnabled: any = createSelector(
  globalState,
  prop(MODIFY_PROFILE_UIGP_OTP_ENABLED)
);

export const selectConsultantDelegationEnabled: any = createSelector(
  globalState,
  prop(DELEGATE_CONSULTANT_ENABLED)
);
